import { Movement, Range } from 'types';

type CreateMovementProps = {
  range: Range;
  movementType: string;
  newFrom?: number;
  newTo?: number;
  newShareClass?: string;
};

export const createMovement = ({
  range,
  movementType,
  newFrom,
  newTo,
  newShareClass,
}: CreateMovementProps): Movement => ({
  partner: range.partner || '',
  shareFrom: range.from,
  shareTo: range.to,
  shareClass: range.shareClass || '',
  ...(newFrom !== undefined && { newShareFrom: newFrom }),
  ...(newTo !== undefined && { newShareTo: newTo }),
  ...(newShareClass !== undefined && { newShareClass }),
  movementType,
});
